import { Checkbox, Field, Form, Grid, Input } from "@alifd/next";
import { BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import MD5 from 'crypto-js/md5';
import Base64 from 'crypto-js/enc-base64';

const UpdateUserPassword = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, id, ...otherProps } = props;
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const [dataSource, setDataSource] = useState({});
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    const refresh = async () => {
        try {
            let result = await befRpc.callRpcAsync<any>("", rpcAssembly, rpcModule, "Get", { Id: id });
            fieldRef.current.setValue("UserId", result.UserId);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户信息获取"));
        }
    }
    const checkPassword = (rule: any, value: any, callback: any) => {
        const { getValue } = fieldRef.current;
        if (value && value !== getValue("Password")) {
            return callback("两次密码输入不一致！");
        } else {
            return callback();
        }
    }

    useEffect(() => {
        fieldRef.current.reset();
        fieldRef.current.setValue("Reset", false);
    }, []);
    useEffect(() => {
        fieldRef.current.setValue("UserId", id);
        // refresh();
    }, [id]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                result.Password = Base64.stringify(MD5(`${result.UserId.toLowerCase()}@${result.Password}`));
                delete result.Password1;
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);
    return (
        <Form field={fieldRef.current} className="bef-custom-user">
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="新密码" name="Password" className="custom-form-control">
                        <Input.Password />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="确认新密码" name="Password1" validator={checkPassword} className="custom-form-control">
                        <Input.Password />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item label="是否重置密码" name="Reset" className="custom-form-control">
                        <Checkbox />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});

export default UpdateUserPassword;